import type { CSSProperties } from "react";

import { Avatar } from "@av/components/atoms/Avatar";

import type { UserAvatar } from "../organisms/type";
import type { AvE2EProps } from "../types";
import type { AvatarProps } from "antd";
import type { AvatarProps as AntdAvatarProps } from "antd/lib";

type EmployeeAvatarProps = AvE2EProps & {
  size?: AvatarProps["size"];
  onClick?: AntdAvatarProps["onClick"];
  className?: string;
  style?: CSSProperties;
  info?: UserAvatar;
  isDemo: boolean;
  title?: string;
};

export function UserAvatar(props: EmployeeAvatarProps) {
  const { testIdPrefix, info, size = "default", onClick, className, style, isDemo, title } = props;
  const { initials, avatarUri, avatarColor } = info ?? {};
  const avatarStyle = avatarColor ? { ...style, backgroundColor: avatarColor } : style;

  if (avatarUri && isDemo) {
    return (
      <Avatar
        testIdPrefix={testIdPrefix}
        size={size}
        src={<img src={avatarUri} />}
        onClick={onClick}
        className={className}
        style={style}
        title={title}
      />
    );
  }

  return (
    <Avatar
      testIdPrefix={testIdPrefix}
      size={size}
      style={avatarStyle}
      onClick={onClick}
      className={className}
      title={title}
    >
      {initials}
    </Avatar>
  );
}
